<template>
  <div class="layout">
    <div class="sidebar">
      <v-select :options="componentList" v-model="selectedComponent" placeholder="Select a component..." :clearable="true" />
      <div v-if="selectedComponent" class="sidebar-table-wrapper">
        <table class="sidebar-table" >
          <tbody>
          <tr>
            <th>Item</th>
            <td>{{ selectedComponent }}</td>
          </tr>
          <tr>
            <th>Purchase Tag</th>
            <td>{{ selectedComponentPurchaseTag }}</td>
          </tr>
          <tr>
            <th>Godown Info</th>
            <td class="godown-info-cell">
              <ul v-if="selectedComponentGodownInfo.length">
                <li v-for="(entry, idx) in selectedComponentGodownInfo" :key="idx">
                  {{ entry.qty }} - {{ entry.godown }}
                </li>
              </ul>
              <span v-else>No godown info</span>
            </td>
          </tr>
          <tr>
            <th>Stock</th>
            <td>{{ selectedComponentStock.stock }}</td>
          </tr>
          <tr>
            <th>Component Outstanding</th>
            <td>{{ selectedComponentOutstanding }}</td>
          </tr>
          <tr>
            <th>Net Available</th>
            <td>{{ (Number(selectedComponentStock.stock) || 0) - (Number(selectedComponentOutstanding) || 0) }}</td>
          </tr>
          <tr>
            <th>Reorder Level</th>
            <td>{{ selectedComponentStock.reorderLevel }}</td>
          </tr>
          <tr>
            <th>PO List</th>
            <td>
                <div>
                <strong>Pending Qty:</strong>
                {{
                  selectedComponentPOList.reduce(
                    (sum, row) => sum + (Number(row.G) || 0),
                    0
                  )
                }}
              </div>
              <table v-if="selectedComponentPOList.length" class="sidebar-POtable">
                <thead>
                  <tr>
                    <th>PO No.</th>
                    <th>PO Date</th>
                    <th>Supplier</th>
                    <th>Ordered Qty</th>
                    <th>Pending Qty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in selectedComponentPOList" :key="idx">
                    <td>{{ row.B }}</td>
                    <td>{{ row.C }}</td>
                    <td>{{ row.D }}</td>
                    <td>{{ row.F }}</td>
                    <td>{{ row.G }}</td>
                  </tr>
                </tbody>
              </table>
              <span v-else>No PO Orders found.</span>
            </td>
          </tr>
          <!-- Add more rows here for other fields as you implement them -->
           </tbody>
        </table>
      </div>
    </div>
    <div class="body">
      <table class="bom-table" v-if="componentOutstandingOrders.length">
        <thead>
          <tr>
            <th>OA Date</th>
            <th>OA</th>
            <th>Customer Name</th>
            <th>Required Components</th>
            <th>FG</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, idx) in componentOutstandingOrders" :key="idx">
            <td>{{ getOADateByOA(row.oa) }}</td>
            <td>{{ row.oa }}</td>
            <td>{{ row.customerName }}</td>
            <td>{{ row.requiredComponents }}</td>
            <td>{{ row.fg }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else-if="selectedComponent">No outstanding orders for this component.</div>
    </div>
  </div> 
</template>

<script>
import vSelect from "vue3-select";
import "vue3-select/dist/vue3-select.css";

const backendUrl = process.env.VUE_APP_BACKEND_URL;

export default {
  name: "ComponentAnalysis",
  components: { vSelect },
  data() {
    return {
      componentList: [],         // Populate this with your component options
      selectedComponent: null,   // The selected component
      selectedComponentPurchaseTag: '',
      selectedComponentGodownInfo: '',
      selectedComponentStock: '',
      selectedComponentOutstanding: '',
      selectedComponentPOList: [],
      componentOutstandingOrders: [],
      oaRegistrarRows: [],
    };
  },

  methods: 
  {
    async getComponentList() {
      try {
        const response = await fetch(`${backendUrl}/excel/StockReorder`);
        const data = await response.json();
        // Directly map the unique items
        this.componentList = Object.keys(data.stockMap || {})
        .filter(Boolean); // removes undefined/null/empty
        // Restore selection from localStorage
        const saved = localStorage.getItem('selectedComponent');
        if (saved && this.componentList.includes(saved)) {
          this.selectedComponent = saved;
        }
        console.log('Fetched data:', data);
        console.log('StockMap:', data.stockMap);
        console.log('componentList:', this.componentList);

      } catch (err) {
        this.componentList = [];
      }
    },

    async fetchPurchaseTagForSelectedComponent() {
  if (!this.selectedComponent) {
    this.selectedComponentPurchaseTag = '';
    return;
  }
  try {
    const response = await fetch(
      `${backendUrl}/excel/purchase-tags?items=${encodeURIComponent(this.selectedComponent)}`
    );
    const data = await response.json();
    this.selectedComponentPurchaseTag = data.purchaseTagMap?.[this.selectedComponent] || '';
  } catch (err) {
    this.selectedComponentPurchaseTag = 'Error fetching purchase tag';
  }
  },

  async fetchGodownInfoForSelectedComponent() {
    if (!this.selectedComponent) {
      this.selectedComponentGodownInfo = [];
      return;
    }
    try {
      const response = await fetch(`${backendUrl}/excel/godown-info`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bomBList: [this.selectedComponent] })
      });
      const data = await response.json();
      // Store the array for the selected component
      this.selectedComponentGodownInfo = data.godownMap?.[this.selectedComponent] || [];
    } catch (err) {
      this.selectedComponentGodownInfo = [];
    }
  },
  async fetchStockForSelectedComponent() {
  if (!this.selectedComponent) {
    this.selectedComponentStock = '';
    return;
  }
  try {
    const params = new URLSearchParams({ items: this.selectedComponent });
    const response = await fetch(`${backendUrl}/excel/StockReorder?${params}`);
    const data = await response.json();
    // Assuming the backend returns { stockMap: { [component]: value } }
    this.selectedComponentStock = data.stockMap?.[this.selectedComponent] ?? '';
  } catch (err) {
    this.selectedComponentStock = 'Error fetching stock info';
  }
    },

  async fetchOutstandingForSelectedComponent() {
      if (!this.selectedComponent) {
        this.selectedComponentOutstanding = '';
        return;
      }
      try {
        const response = await fetch(`${backendUrl}/excel/bomdata/component-outstanding-by-component`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ component: this.selectedComponent })
        });
        const data = await response.json();
        this.selectedComponentOutstanding = data.outstanding ?? '';
      } catch (err) {
        this.selectedComponentOutstanding = 'Error fetching outstanding info';
      }
    },

  async fetchPOListForSelectedComponent() {
      if (!this.selectedComponent) {
        this.selectedComponentPOList = [];
        return;
      }
      try {
        const response = await fetch(`${backendUrl}/excel/po-list/by-component`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ component: this.selectedComponent })
        });
        const data = await response.json();
        this.selectedComponentPOList = data.poList || [];
      } catch (err) {
        this.selectedComponentPOList = [];
      }
    },

  async fetchComponentOutstandingOrders() {
    if (!this.selectedComponent) {
      this.componentOutstandingOrders = [];
      return;
    }
    try {
      const response = await fetch(`${backendUrl}/excel/bomdata/ComponentOutstandingOrders`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ component: this.selectedComponent })
      });
      const data = await response.json();
      this.componentOutstandingOrders = data.items || [];
    } catch (err) {
      this.componentOutstandingOrders = [];
    }
  },

  async fetchOARegistrarRows() {
    try {
      const response = await fetch(`${backendUrl}/excel/oa-registrar`);
      const data = await response.json();
      this.oaRegistrarRows = data.items || [];
    } catch (err) {
      this.oaRegistrarRows = [];
    }
  },

  getOADateByOA(oa) {
  // oaRegistrarRows: array of arrays, where [3] is column D, [0] is column A
  const match = this.oaRegistrarRows.find(row => row[3] === oa);
  return match ? match[0] : '';
},

  },

  watch: {
    selectedComponent(newVal) {
      if (newVal !== null && newVal !== undefined) {
        localStorage.setItem('selectedComponent', newVal);
      } else {
        localStorage.removeItem('selectedComponent');
      }
      this.fetchPurchaseTagForSelectedComponent();
      this.fetchGodownInfoForSelectedComponent();
      this.fetchStockForSelectedComponent();
      this.fetchOutstandingForSelectedComponent();
      this.fetchPOListForSelectedComponent();
      this.fetchComponentOutstandingOrders();
      this.fetchOARegistrarRows();
    }
  },
  
    mounted() {
    this.getComponentList();

  }
  

};
</script>

<style scoped>
.layout {
  display: flex;
  gap: 2em;
  align-items: flex-start;
  background: #f7fafd;
  min-height: 100vh;
  padding: 2em 0;
}

/* Sidebar */
.sidebar {
  width: 500px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px #b0b8c940;
  padding: 2em 1.5em 1.5em 1.5em;
  font-family: 'Segoe UI', Arial, sans-serif;
  color: #2d3748;
  display: flex;
  flex-direction: column;
  gap: 2em;
  border: 1px solid #e3e8ee;
}

.sidebar .v-select {
  margin-bottom: 1.5em;
}

.sidebar-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.sidebar-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 0.5em;
  font-size: 0.9em;
  background: #f8fafc;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 6px #b0b8c930;
}

.sidebar-table th, .sidebar-table td {
  border: 1px solid #e3e8ee;
  padding: 0.5em 0.85em;
  text-align: left;
}

.sidebar-table th {
  background: #e3e8ee;
  color: #3b4252;
  font-weight: 700;
  width: 40%;
}

.sidebar-table td {
  background: #f8fafc;
  color: #2d3748;
}

.sidebar-table tr:nth-child(even) td {
  background: #f1f5f9;
}

.sidebar-POtable {
  font-size: x-small;
}

.godown-info-cell ul {
  padding-left: 1em;
  margin: 0;
  list-style: disc;
}

.godown-info-cell li {
  margin-bottom: 2px;
  color: #444;
}

strong {
  color: #2563eb;
  font-weight: 700;
}

/* Main body */
.body {
  flex: 1;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px #b0b8c930;
  padding: 2em 2em 1.5em 2em;
  font-family: 'Segoe UI', Arial, sans-serif;
  color: #2d3748;
  min-width: 0;
  border: 1px solid #e3e8ee;
  overflow-x: auto;
}

.bom-table {
  min-width: 900px;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 1em;
  font-size: 0.9em;
  background: #f8fafc;
  border-radius: 10px;
  overflow: auto;
  box-shadow: 0 1px 6px #b0b8c930;
}

.bom-table th, .bom-table td {
  border: 1px solid #e3e8ee;
  padding: 0.7em 1em;
  text-align: left;
  white-space: nowrap;
}

.bom-table th {
  background: #e3e8ee;
  color: #2563eb;
  font-weight: 700;
  position: sticky;
  top: 0;
  z-index: 1;
}

.bom-table tr:nth-child(even) {
  background: #f1f5f9;
}

@media (max-width: 1100px) {
  .layout {
    flex-direction: column;
    gap: 1.5em;
    padding: 1em 0.5em;
  }
  .sidebar {
    max-width: 100%;
    min-width: 0;
    margin-bottom: 1.5em;
  }
  .body {
    padding: 1em 0.5em;
  }
}
</style>